import type { Client } from "./client";
import type { Device } from "./device";
import type { Item } from "./items";
import type { User } from "./user";
import type { Vehicle } from "./vehicle";

export enum RfidTagType {
  HARD = "hard",
  LABEL = "label",
}

export enum RfidTagStatus {
  LINKED = "linked",
  NOT_LINKED = "not_linked",
}

export interface RfidTag {
  id: number;
  rfid: string;
  type: RfidTagType;
  status: RfidTagStatus;
  item: Item | null;
  vehicle: Vehicle | null;
  client: Client;
  created_by: User;
  updated_by: User;
  lastReadByDevice: Device | null;
  last_scan: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRfidTagPayload {
  rfid: string;
  type: RfidTagType;
  status?: RfidTagStatus;
  item_id?: number;
  vehicle_id?: number;
  client_id: number;
}

/**
 * Fields an update may send. Only what is sent changes; the status field is a
 * mirror of the link and is never sent by the web.
 */
export interface UpdateRfidTagPayload {
  rfid?: string;
  type?: RfidTagType;
  item_id?: number | null;
  vehicle_id?: number | null;
}
